import React from "react";
import { useTheme } from "@mui/material/styles";
import { Typography, Grid, Box, Avatar, Chip } from "@mui/material";

const MemberEntry = ({ name = "Team Member", role = "Contributor" }) => {
  const theme = useTheme();
  
  // Create initials safely
  const getInitials = (nameString) => {
    if (!nameString || typeof nameString !== 'string') return '?';
    try {
      return nameString.match(/\b(\w)/g)?.join("") || nameString.charAt(0);
    } catch (e) {
      return nameString.charAt(0) || '?';
    }
  };
  
  return (
    <Box
      alignItems="center"
      key={name}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: theme.palette.primary.main,
        mb: "1em",
        p: "1em",
        borderRadius: "4px",
      }}
    >
      <Box>
        <Typography variant="h5">{name}</Typography>
        <Typography variant="subtitle2">{role}</Typography>
      </Box>
      <Box>
        <Avatar sx={{ width: "2.5em", height: "2.5em" }}>
          {getInitials(name)}
        </Avatar>
      </Box>
    </Box>
  );
};

export default MemberEntry;
